import { render, staticRenderFns } from "./SquareLinkedinIcon.vue?vue&type=template&id=19066920&"
import script from "./SquareLinkedinIcon.vue?vue&type=script&lang=js&"
export * from "./SquareLinkedinIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports